<template>
    <div class="cer-content">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('certifications.title')}}
                <hr>
            </span>
        </h1>
        <div class="row cer-row">
            <ul>
                <li v-for="(item,index) in cerimglist" :key="index">
                    <img :src="item.url" alt="">
                </li>
            </ul>
        </div>
        <div class="row">
            <p v-for="item in $t('certifications.itemList')" style="margin-top:20px">{{item}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                cerimglist:[
                    {
                        url:require('../../assets/images/latf_logo.png'),
                    },{
                        url:require('../../assets/images/iso_logo.png'),
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .cnas-log{
        display: block;
        max-width: 100%;
        height: auto;
        margin:2rem auto;
    }
    .cer-row ul{
        width:50%;
        margin:2rem auto;
        overflow: hidden;
    }
    .cer-row ul li{
        float:left;
        width: 50%;
    }
    .cer-row ul li img{
        display: block;
        max-width: 100%;
        height:auto;
        margin:0 auto;
    }
    .cer-row ul li span{
        display: block;
        text-align: center;
        margin-top: 1rem;
        font-size: 1.5rem;
    }
    @media (max-width: 767px){
        .cer-row ul{
            width:auto;
        }
        .cer-row ul li{
            width: 50%;
            margin-bottom: 1rem;
        }
        .cer-row ul li img{
            width: 7.5rem;
        }
        .cer-row ul li span{
            font-size: .7rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Services/Certifications.vue